module.exports = __webpack_public_path__ + "static/media/IMG_5007.fec0772b.JPG";